export const REPORT_ATTACHMENT_OUTBOX_TABLE = 'reportAttachments';
